"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductClient = void 0;
var client_1 = require("./client");
Object.defineProperty(exports, "ProductClient", { enumerable: true, get: function () { return client_1.ProductClient; } });
//# sourceMappingURL=index.js.map